/**
 * Announcement Bar Layout Adjustment
 *
 * Handles dynamic layout spacing for announcement bar + top-bar.
 * All scheduling logic is handled server-side in Liquid for security.
 */

/**
 * Adjust layout spacing for announcement bar + top-bar
 * This ensures both bars are visible and the header is positioned correctly
 */
function adjustAnnouncementBarSpacing() {
  const announcementSection = document.querySelector('.announcement-bar-section');
  const topBar = document.querySelector('.top-bar');
  const header = document.querySelector('.header');

  if (!announcementSection || !topBar || !header) {
    return;
  }

  // Read every geometric property up front, then write. Interleaving reads and
  // writes forces a synchronous reflow on each read, which showed up in
  // Lighthouse as ~69ms of forced reflow attributed to this file.
  // Reading topBar height before the writes is equivalent: the writes only set
  // `top` and `margin-top`, neither of which changes the bar's own height.
  const announcementHeight = announcementSection.offsetHeight;
  const topBarHeight = topBar.offsetHeight;

  // Update CSS custom property for dynamic spacing
  document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);

  // Update top-bar position
  topBar.style.top = `${announcementHeight}px`;

  // Update header margin (announcement + top-bar)
  header.style.marginTop = `${announcementHeight + topBarHeight}px`;
}

// Coalesce bursts of resize events into one measurement per animation frame.
// Running the handler on every event caused a forced reflow per event.
let pendingFrame = null;
function scheduleAdjustment() {
  if (pendingFrame !== null) return;
  pendingFrame = requestAnimationFrame(() => {
    pendingFrame = null;
    adjustAnnouncementBarSpacing();
  });
}

// Run on page load, then once more shortly after so late layout changes
// (web fonts finishing, images settling) are picked up.
function runInitialAdjustments() {
  adjustAnnouncementBarSpacing();
  setTimeout(adjustAnnouncementBarSpacing, 100);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runInitialAdjustments);
} else {
  runInitialAdjustments();
}

// Re-adjust on window resize
window.addEventListener('resize', scheduleAdjustment);
